import type { PortalView } from 'dfx/edge/edge.did';

export const isFavorited = (portal: PortalView, favorites?: PortalView[]) => {
  if (!favorites) {
    return false;
  }
  return favorites.some((p) => p.slug === portal.slug);
};
